export default "__VITE_ASSET__CIUFRUVK__"